/* ==========================================================================
   NASH MARKET — Le passepoil (§3.1)
   La correction trilingue : la durée du défilement n'est PAS fixe.

   Une marquee à durée fixe défile d'autant plus vite que son contenu est long.
   La version russe du bandeau fait 30 à 40 % de plus que la française : à 32 s
   pour tout le monde, le russe passerait à ~55 px/s et le français à ~40 px/s.
   On fixe donc la VITESSE (42 px/s) et on en déduit la durée depuis la largeur
   réellement mesurée après mise en page.
   ========================================================================== */
(function () {
  'use strict';

  /* 42 px/s : au-delà, le regard décroche sur une bande de 40 px ; en deçà,
     le cinquième argument n'est jamais atteint avant que le visiteur défile. */
  var VITESSE = 42;

  function mouvementCoupe() {
    if (document.documentElement.getAttribute('data-nm-motion') === 'off') return true;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function caler(bandeau) {
    var piste = bandeau.querySelector('[data-marquee-track]');
    if (!piste) return;

    /* Mouvement coupé : le CSS a déjà masqué la seconde copie et arrêté
       l'animation. On retire la durée pour ne pas laisser un état mort
       derrière nous si le réglage système change en cours de session. */
    if (mouvementCoupe()) {
      piste.style.removeProperty('--nm-marquee-dur');
      return;
    }

    /* scrollWidth couvre les DEUX copies ; l'animation ne parcourt que la
       moitié (translateX(-50 %)), d'où la division. */
    var parcours = piste.scrollWidth / 2;
    if (!parcours || parcours < 1) return;

    piste.style.setProperty('--nm-marquee-dur', (parcours / VITESSE).toFixed(2) + 's');
  }

  /* --nm-bandeau-h, mesuré et non supposé (§5.1 : « idem pour --nm-bandeau-h »).
     Trois cas où la valeur nominale de 40 px est fausse et où le hero se
     tromperait de plusieurs dizaines de pixels sur son calc(100svh - ...) :
     sous 900 px la bande est en display:none, en mouvement réduit elle se
     replie sur plusieurs lignes, et le zoom texte du navigateur la grandit.
     Le repli CSS (le :root sous 900 px de nash-bandeau.css) reste en place
     pour le cas sans JS ; ici on écrit en ligne sur <html>, donc on gagne. */
  function mesurerHauteur() {
    var bandeau = document.querySelector('[data-nm-bandeau]');
    var h = bandeau ? Math.round(bandeau.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--nm-bandeau-h', h + 'px');
  }

  function calerTout(racine) {
    var hote = racine && racine.querySelectorAll ? racine : document;
    Array.prototype.forEach.call(hote.querySelectorAll('[data-nm-bandeau]'), caler);
    mesurerHauteur();
  }

  /* Premier calage au plus tôt, puis re-calage quand les vraies polices
     arrivent : Fira Sans Condensed n'a pas la chasse de son repli, la largeur
     mesurée avant le swap serait fausse de plusieurs pour cent. */
  function demarrer() {
    calerTout(document);
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(function () { calerTout(document); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }

  /* La largeur du texte bouge au changement de langue, de zoom ou de police
     système. ResizeObserver sur la piste attrape tout cela sans sonder. */
  if (window.ResizeObserver) {
    var observateur = new ResizeObserver(function (entrees) {
      var hauteurATester = false;
      for (var i = 0; i < entrees.length; i++) {
        var cible = entrees[i].target;
        /* La bande elle-même n'est observée que pour sa hauteur ; recalculer la
           durée depuis elle ferait boucler l'observateur avec la piste. */
        if (cible.hasAttribute('data-nm-bandeau')) { hauteurATester = true; continue; }
        var bandeau = cible.closest('[data-nm-bandeau]');
        if (bandeau) { caler(bandeau); hauteurATester = true; }
      }
      if (hauteurATester) mesurerHauteur();
    });
    var brancher = function () {
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-nm-bandeau] [data-marquee-track]'),
        function (piste) { observateur.observe(piste); }
      );
      /* En display:none l'observateur rapporte 0 × 0 : c'est exactement ce
         qu'il faut sous 900 px, la mesure suit la bascule sans media query JS. */
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-nm-bandeau]'),
        function (bandeau) { observateur.observe(bandeau); }
      );
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher, { once: true });
    } else {
      brancher();
    }
  }

  /* Le réglage système peut basculer pendant la visite (mode économie, réglage
     d'accessibilité). On recalcule plutôt que de laisser une durée orpheline. */
  if (window.matchMedia) {
    var requete = window.matchMedia('(prefers-reduced-motion: reduce)');
    var surChangement = function () { calerTout(document); };
    if (requete.addEventListener) requete.addEventListener('change', surChangement);
    else if (requete.addListener) requete.addListener(surChangement);
  }

  /* Éditeur de thème : la section est réinjectée sans rechargement de page,
     donc sans nouvelle exécution de ce fichier. */
  document.addEventListener('shopify:section:load', function (e) {
    calerTout(e.target);
    if (window.ResizeObserver && observateur) {
      Array.prototype.forEach.call(
        e.target.querySelectorAll('[data-nm-bandeau] [data-marquee-track]'),
        function (piste) { observateur.observe(piste); }
      );
      Array.prototype.forEach.call(
        e.target.querySelectorAll('[data-nm-bandeau]'),
        function (bandeau) { observateur.observe(bandeau); }
      );
    }
  });

  /* Section retirée dans l'éditeur : sans ce reset, --nm-bandeau-h resterait à
     40 px et le hero se croirait toujours sous un auvent qui n'existe plus. */
  document.addEventListener('shopify:section:unload', function () {
    /* L'événement peut partir avant le détachement réel du nœud : on mesure à
       la frame suivante, sinon on relèverait la hauteur d'une bande fantôme. */
    if (window.requestAnimationFrame) requestAnimationFrame(mesurerHauteur);
    else mesurerHauteur();
  });
})();
